import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./DiscoveryManagement.scss";
import "../../styles/global.scss";
import "../../styles/pagelayout.scss";
// @ts-ignore
import Cookies from "js-cookie";
// React Bootstrap components
import { Container, Row, Col } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Auth from "@aws-amplify/auth";

// Components
import Sidebar from "../components/sidebar/Sidebar";

// Functions
import AddPartnerRequest from "../components/modalForms/DiscoveryManagement/PartnerRequest";
import {
  GetAllBrandRequests,
  getBrandRequests,
  GetBrandRequests,
  GetBrandRequestsDataRestriction,
  GetBrandRequestsForOrg,
  GetOrgBrands,
} from "../../API/endpoints/Discovery";
import { PartnerRequestsDTO } from "../dtos/discovery";
import { GetUserProfile } from "../../API/endpoints/User";
import Navbar from "../components/header/NavBar";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../API/endpoints/RolesAndPermissions/Roles";
import { GetPublicFiles } from "../../API/endpoints/fileupload/Files";
import DiscoveryBrandList from "../components/list/DiscoveryBrandList";
import { DATE_FORMAT_DD_MM_YYYY, STATUS_INTEREST_ACCEPTED, STATUS_INTEREST_EXPRESSED, STATUS_INTEREST_RECEIVED, STATUS_INTERESTS_EXPRESSED, STATUS_INTERESTS_RECEIVED, STATUS_OPEN, STATUS_PARTNER_INTEREST_ACCEPTED, STATUS_PARTNER_INTEREST_EXPRESSED, STATUS_PENDING } from "../../constants/constants";
import { Button, Input, InputRef, Table, TableProps, Tag } from "antd";
import DiscoverBrandItemCell from "../dashboard/brand/components/DiscoverBrandItemCell";
import dayjs from "dayjs";
import { FilterDropdownProps } from "antd/es/table/interface";
import SearchIconSmall from "../../components/icons/SearchIconSmall";
import SortIcon from "../../components/icons/SortIcon";
import { discoverStatusListBrand } from "../../constants/dataConstants";
import FilterIcon from "../../components/icons/FilterIcon";


const PAGE_SIZE = 20;

function BrandDiscoveryManagement() {
  const navigate = useNavigate();
  const params = useParams();

  const tableRef = useRef<any>(null);
  const searchInput = useRef<InputRef>(null);

  const routeToForm = () => {
    setShowPartnerModal(true);
  };

  const [flag, setFlag] = useState(false);
  const [showPartnerModal, setShowPartnerModal] = useState(false);
  const [brandsList, setBrandsList] = useState<any[]>([]);
  const [dataCount, setDataCount] = useState(0);
  const [listPage, setListPage] = useState(0);
  const [searchParam, setSearchParam] = useState<string>("");
  const [usertype, setUsertype] = useState<string | undefined>("");
  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [dataRestriction, setDataRestriction] = useState(false);
  const [orgId, setOrgId] = useState<string | undefined>("");
  const [roleID, setRoleID] = useState<string>("");
  const [permissions, setPermissions] = useState<any[]>([]);
  // const [publicFiles, setPublicFiles] = useState<any>([]);

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  const [scrollY, setScrollY] = useState(0);


  const [searchKey, setSearchKey] = useState("");
  const [filterStatuses, setFilterStatuses] = useState<string[]>([])
  const [sorter, setSorter] = useState({ field: "", order: "" })


  const handleClose = () => {
    setFlag((prev) => !prev);
    setShowPartnerModal(false);
  };

  // const columns = BrandDiscoveryTableColumns(
  //   navigate,
  //   setIsDetailsModalOpen,
  //   setSelectedRequestID,
  //   setSelectedRequest,
  //   setSelectedRequestBrandID,
  //   usertype,
  //   permissions
  // );

  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  useEffect(() => {

    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setRoleID(response.data?.user_roles[0]?.roles.id);
          setOrgId(response.data?.organization?.id);
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID, navigate]);

  useEffect(() => {
    (async () => {
      const roleDetails = await GetRoleById(roleID?.toString());
      setDataRestriction(roleDetails?.data?.data_restriction);

      if (roleDetails?.data?.type === "organization") {
        const response = await GetPermissionsByRoleAndModuleID(
          roleID?.toString(),
          "10"
        );
        setPermissions(response?.data);
      } else if (roleDetails?.data?.type === "administrative") {
        const response = await GetPermissionsByRoleAndModuleID(
          roleID?.toString(),
          "5"
        );
        setPermissions(response?.data);
      }
    })();
  }, [roleID]);



  useEffect(() => {
    setUsertype(params.usertype);
  }, [params]);

  useEffect(() => {
    const updateScrollY = () => {
      if (tableRef.current) {
        const containerHeight = tableRef.current.clientHeight;
        const headerHeight = 72; // Adjust this value if your header is bigger/smaller
        setScrollY(containerHeight - headerHeight);
      }
    };

    updateScrollY();
    window.addEventListener('resize', updateScrollY);
    return () => window.removeEventListener('resize', updateScrollY);
  }, []);



  const loadData = async (pageNumber: number) => {
    setLoading(true);
    getBrandRequests(page, PAGE_SIZE, undefined, undefined, filterStatuses, undefined, searchKey, sorter?.order, sorter?.field).then((res) => {
      const newData = res?.data?.map((item: any) => {
        const counts = item?.counts && item?.counts?.length > 0 ? item?.counts[0] : {}
        return {
          id: item?.id,
          brand_name: item?.brand?.brand_name,
          category: item?.category,
          subCategory: item?.sub_category,
          suitable_count: counts?.suitable_count || 0,
          interested_count: counts?.interested_count || 0,
          recommended_count: counts?.recommended_count || 0,
          updatedAt: item?.updated_at,
          createdAt: item?.created_at,
          status: item?.status === STATUS_OPEN ? STATUS_PENDING : item?.status === STATUS_PARTNER_INTEREST_EXPRESSED ? STATUS_INTERESTS_RECEIVED : item?.status,
        }
      }) || []
      pageNumber == 1 ? setData(newData) : setData(prev => [...prev, ...newData]);
      const total = res?.totalCount || 0;
      setHasMore((pageNumber * PAGE_SIZE) < total);
      setLoading(false);
    }).catch((err) => {
      console.log("Failed to fetch brand requests", err);
      setLoading(false);
      setHasMore(false);
      setData([]);
    })


  };

  useEffect(() => {
    setPage(1);
    loadData(1);
  }, [searchKey, filterStatuses, sorter])

  useEffect(() => {
    loadData(page);
  }, [page]);

  const onViewDetails = (id: string) => {
    navigate(`/discoverymanagement/brand-request/${id}`)
  }



  const handleTableChange = (_: any, filters: any, sorter: any) => {
    const sortOrder = sorter?.order ? sorter?.order === "ascend" ? "ASC" : "DESC" : undefined
    setFilterStatuses(filters?.status || []);
    setSorter({ field: sorter?.field || "", order: sortOrder || "" })
  }


  const handleSearch = (selectedKeys: any, confirm: any) => {
    confirm();
    if (selectedKeys[0] != undefined) {
      setSearchKey(selectedKeys[0]?.trim());
    }
  };

  const handleReset = (clearFilters: any, confirm: any) => {
    clearFilters();
    setSearchKey("");
    confirm();
  };


  const getColumnSearchProps = (dataIndex: any) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }: FilterDropdownProps) => (
      <div style={{ padding: 8 }}>
        <Input
          classNames={{
            input: "text-[12px]"
          }}
          ref={searchInput}
          placeholder={`Search`}
          value={selectedKeys[0]}
          prefix={<SearchIconSmall />}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys as string[], confirm)}
          className="mb-[8px]"
        />
        <div className="flex gap-2 justify-end">
          <Button
            onClick={() => clearFilters && handleReset(clearFilters, confirm)}
            size="small"
            className="text-[12px]"
          >Reset</Button>
          <Button
            type="primary"
            title="Search"
            size="small"
            className="text-[12px]"
            onClick={() => handleSearch(selectedKeys as string[], confirm)}
          >Search</Button>
        </div>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchIconSmall color={filtered ? "#0152FB" : "#667085"} />
    ),
  });


  const columns: TableProps['columns'] = [
    {
      title: 'Brand Name',
      dataIndex: 'brand_name',
      key: 'brand_name',
      render: (brand: string, record: any) => (
        <DiscoverBrandItemCell data={record} />
      ),
      ...getColumnSearchProps("brand_name")
    },
    {
      title: 'Suitable Partners',
      dataIndex: 'suitable_count',
      key: 'suitable_count',
      className: "font-[500]",
      align: "center",
      width: 180,
      sorter: true,
      sortIcon: ({ sortOrder }) => <SortIcon order={sortOrder} />,
      render: (value: number) => (
        <>{value?.toString().padStart(2, "0")}</>
      )
    },
    {
      title: 'Interested Partners',
      dataIndex: 'interested_count',
      key: 'interested_count',
      className: "font-[500]",
      align: "center",
      width: 180,
      sorter: true,
      sortIcon: ({ sortOrder }) => <SortIcon order={sortOrder} />,
      render: (value: number) => (
        <>{value?.toString().padStart(2, "0")}</>
      )
    },
    {
      title: 'Recommended Partners',
      dataIndex: 'recommended_count',
      key: 'recommended_count',
      className: "font-[500]",
      align: "center",
      width: 200,
      sorter: true,
      sortIcon: ({ sortOrder }) => <SortIcon order={sortOrder} />,
      render: (value: number) => (
        <>{value?.toString().padStart(2, "0")}</>
      )
    },
    {
      title: 'Updated',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      className: "font-[500]",
      sorter: true,
      sortIcon: ({ sortOrder }) => <SortIcon order={sortOrder} />,
      render: (value: string) => (
        <>{value ? dayjs(value).format(DATE_FORMAT_DD_MM_YYYY) : ""}</>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      filters: discoverStatusListBrand,
      filterIcon: (filtered: boolean) => (
        <FilterIcon filtered={filtered} />
      ),
      render: (status: string) => {

        const statusText = status === STATUS_OPEN ? STATUS_PENDING : status === STATUS_INTEREST_EXPRESSED ? STATUS_INTEREST_RECEIVED : status;
        let color = "warning";
        if (statusText === STATUS_INTEREST_RECEIVED) {
          color = "purple"
        } else if (statusText === STATUS_INTEREST_EXPRESSED || statusText === STATUS_PARTNER_INTEREST_EXPRESSED) {
          color = "blue"
        } else if (statusText === STATUS_INTEREST_ACCEPTED || statusText === STATUS_PARTNER_INTEREST_ACCEPTED) {
          color = "success"
        } else {
          color = "warning"
        }

        return <Tag bordered={false} className="capitalize !rounded-[24px] text-[10px] font-[500]" color={color}>{statusText?.replaceAll("_", " ")?.toLowerCase()}</Tag>
      }
    },
    {
      title: false,
      dataIndex: 'action',
      key: 'action',
      align: "end",
      render: (status: string, record: any) => (
        <Button
          type="text"
          className="leading-[13px] text-[13px] !text-[#0152FB] bg-[#EFF8FF] hover:!bg-[#D1E9FF] font-[500]"
          onClick={() => onViewDetails(record?.id)}
        >
          View Details
        </Button>
      )
    },
  ];



  return (
    <Container fluid className="pge-layout">
      <Row className="row">
        <Col className="sidebar">
          <Sidebar active="discovery" />
        </Col>
        <Col className="content-section w-[calc(100%-60px)]">
          <Navbar userProfile={userProfile} />
          <Breadcrumb className="font12-medium breadcrumb-nav">
            <Breadcrumb.Item>
              DISCOVERY MANAGEMENT
              {/* {usertype === "brand" && (
                <Link to="/discoverymanagement/org">DISCOVERY MANAGEMENT</Link>
              )}
              {usertype === "admin" && (
                <Link to="/discoverymanagement/admin">
                  DISCOVERY MANAGEMENT
                </Link>
              )} */}
            </Breadcrumb.Item>
            <Breadcrumb.Item active></Breadcrumb.Item>
          </Breadcrumb>

          <div
            ref={tableRef}
            className='overflow-auto h-[calc(100vh-99px)] p-[16px]'
          >
            <Table
              dataSource={data}
              columns={columns}
              size="small"
              pagination={false}
              rowKey="id"
              loading={loading}
              onChange={handleTableChange}
              scroll={{ y: scrollY, x: "max-content" }}
              onScroll={(e) => {
                const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
                if (!loading && hasMore && scrollHeight - scrollTop <= clientHeight + 100) {
                  setPage(prev => prev + 1);
                }
              }}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default BrandDiscoveryManagement;
